<template>
  <v-container class="pa-1" grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-container class="pa-0" v-if="lAction === 'view'">
          <v-layout>
            <v-flex xs12 md9 mx-auto>
              <!-- list of units -->
              <div v-for="(hType, t) in types" :key="t">
                <v-card class="mb-3 ma-1">
                  <v-card-title class="pa-2 grey lighten-4">
                    <div class="title grey--text">{{hType}}</div>
                  </v-card-title>
                  <v-card-text class="pa-0">
                    <v-data-table
                    :headers="!$vuetify.breakpoint.smAndUp || t === 1?accHead:accHeadSm"
                    :items="accs.filter(rec => rec.bc_acc_type === hType)"
                    hide-actions
                    class="elevation-0"
                    >
                    <template slot="items" slot-scope="props">
                      <tr @click="prepareUpdate(props.item)">
                        <td>{{ props.item.bc_acc_name }}</td>
                        <td v-if="$vuetify.breakpoint.smAndUp && t === 0">{{ props.item.bank_acc_type }}</td>
                        <td>{{ handy.formatCur(Math.abs(props.item.tot_debit_amount - props.item.tot_credit_amount)) }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </div>

            <v-speed-dial
            :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
            v-model="fab"
            >
            <v-btn
            slot="activator"
            v-model="fab"
            color="accent"
            dark fab
            >
            <v-icon>add</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
          <v-btn fab dark small color="green" @click="prepareCreate('Bank')">
            <v-icon>account_balance</v-icon>
          </v-btn>
          <v-btn fab dark small color="indigo" @click="prepareCreate('Cash')">
            <v-icon>money</v-icon>
          </v-btn>
        </v-speed-dial>
      </v-flex>
    </v-layout>
  </v-container>

  <!-- create / update account details -->
  <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
          <v-card flat>
            <v-flex xs12 sm6 mx-auto>
              <v-card-title class="title pb-0">
                {{ handy.startWithUpper(lAction) + (lAcc.bc_acc_type ? ' ' + handy.startWithUpper(lAcc.bc_acc_type) : '') }} Account
              </v-card-title>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                    label="Account name"
                    v-model="lAcc.bc_acc_name"
                    :rules="[rules.required]"
                    :hint="lAcc.bc_acc_type === 'Bank' ? 'Eg:- ICICI Current A/C, SBI FD, etc...' : 'Eg:- Petty cash, Cash on hand, etc...'"
                    persistent-hint
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 v-if="lAcc.bc_acc_type === 'Bank'">
                    <v-select
                    label="Type"
                    v-model="lAcc.bank_acc_type"
                    :rules="[rules.required]"
                    :items="bankTypes"
                    @input="$forceUpdate()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 mx-auto>
                    <v-card class="grey lighten-4">
                      <v-card-text>
                        <v-layout row wrap v-if="lAcc.no_tran_yet || sAction==='update-balance'">
                          <v-flex xs6>
                            <v-text-field
                            :label="lAcc.no_tran_yet ? 'Opening balance' : 'New balance'"
                            v-model="lAcc.bc_acc_bal"
                            hide-details
                            @input="updateBal()"
                            type="number"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 v-if="sAction==='update-balance'" class="mt-4 text-xs-center caption" style="border:1px solid orange">
                            <span class="subheading">Difference:
                              <span class="subheading info--text">{{handy.formatCur(lAcc.bal_diff)}}</span>
                            </span>
                          </v-flex>
                          <v-flex xs12 v-if="sAction==='update-balance' && ((lAcc.bank_acc_type !== 'Loan' && lAcc.bal_diff > 0) || (lAcc.bank_acc_type === 'Loan' && lAcc.bal_diff < 0))">
                            <v-select
                            label="Reason for difference"
                            v-model="lAcc.credit_gl_acc_id"
                            :rules="[rules.required]"
                            :items="incomeHeads"
                            item-value="gl_acc_id"
                            item-text="gl_acc_name"
                            hide-details
                            return-object
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 v-else-if="sAction==='update-balance' && lAcc.bal_diff !== 0">
                            <v-select
                            label="Reason for difference'"
                            v-model="lAcc.debit_gl_acc_id"
                            :rules="[rules.required]"
                            :items="expHeads"
                            item-value="gl_acc_id"
                            item-text="gl_acc_name"
                            hide-details
                            return-object
                            ></v-select>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap v-else>
                          <v-flex xs8 sm9>
                            <div class="caption">Balance </div>
                            <div class="title info--text">{{ handy.formatCur(lAcc.bc_acc_bal)}}</div>
                          </v-flex>
                          <v-flex xs4 sm3>
                            <v-btn small flat @click="sAction = 'update-balance'">Update</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex xs6>
                    <v-text-field
                    label="Min balance"
                    v-model="lAcc.min_bal"
                    hide-details
                    :disabled="!lAcc.is_alert_min_bal"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-switch
                    class="mt-3"
                    :label="$vuetify.breakpoint.smAndUp ? 'Min balance alert' : 'Alert'"
                    v-model="lAcc.is_alert_min_bal"
                    :rules="[rules.required]"
                    hide-details
                    ></v-switch>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="cancelChanges">Cancel</v-btn>
                <v-btn v-if="lAction === 'update'" @click.native="deleteAcc">Delete</v-btn>
                <v-btn type="submit" :disabled="beingSaved" color="accent">Save</v-btn>
              </v-card-actions>
            </v-flex>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>

  <!-- common elements for alert & loading spinner -->
  <v-snackbar :color="sbarCol" v-model="sbar" :timeout="2000" multi-line>
    <span class="mx-auto">{{ sbarMsg }}</span>
  </v-snackbar>

</v-flex>
</v-layout>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      // common
      lAction: '',
      sAction: '',
      lAcType: '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      fab: false,

      // screen specific
      lAcc: '',
      accs: [],
      types: ['Bank', 'Cash'],
      bankTypes: ['Savings', 'Current', 'Deposit', 'Loan'],
      accHead: [
        { text: 'A/C Name', value: 'bc_acc_name', width: '200px' },
        { text: 'Balance', value: 'cur_bal' }
      ],
      accHeadSm: [
        { text: 'A/C Name', value: 'bc_acc_name', width: '200px' },
        { text: 'Type', value: 'bank_acc_type', width: '50px' },
        { text: 'Balance', value: 'cur_bal', width: '50px' }
      ],
      incomeHeads: [],
      expHeads: []
    }
  }, // data
  created () {
    this.loadAccs()
    this.loadIncomeExpHeads()
    this.lAction = 'view'
  },
  methods: {
    // common methods
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    // screen specific methods
    loadAccs () {
      // existing accounts
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getBankCashAccountsByCommId/', qry)
      .then(response => {
        this.accs = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.accs = []
      })
    },
    loadIncomeExpHeads () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getIncomeExpenseHeadsByCommId/', qry)
      .then(response => {
        this.incomeHeads = response.data.filter(rec => rec.gl_acc_type === 'INCOME')
        this.expHeads = response.data.filter(rec => rec.gl_acc_type === 'EXPENSE')
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.incomeHeads = []
        this.expHeads = []
      })
    },
    prepareUpdate (curAcc) {
      this.lAcc = Object.assign({}, curAcc) // keep the original object safely before changes
      this.lAcc.bc_acc_bal = Math.abs(this.lAcc.tot_debit_amount - this.lAcc.tot_credit_amount)
      this.lAcc.prev_acc_bal = this.lAcc.bc_acc_bal
      this.lAcc.prev_acc_name = this.lAcc.bc_acc_name
      this.lAcc.prev_acc_type = this.lAcc.bank_acc_type
      this.lAcc.debit_gl_acc_id = ''
      this.lAcc.credit_gl_acc_id = ''
      this.lAcc.bal_diff = 0
      // allow to update the opening balance in case there is no other transaction
      var qry = {
        params: {
          gl_acc_id: this.lAcc.gl_acc_id
        }
      }
      this.axios.get(config.API_URL + '/getTotTransByAccId/', qry)
      .then(response => {
        this.lAcc.no_tran_yet = response.data[0].tot === 0
        this.lAcc.no_op_bal_yet = !this.lAcc.tot_debit_amount && !this.lAcc.tot_credit_amount
        this.lAction = 'update'
        this.sAction = ''
      })
    },
    prepareCreate (curType) {
      this.lAcc = this.getEmptyAcc()
      this.lAcc.bc_acc_type = curType
      this.lAction = 'create'
      this.sAction = ''
      this.fab = false
    },
    updateBal () {
      this.lAcc.bal_diff = this.lAcc.bc_acc_bal - this.lAcc.prev_acc_bal
      this.lAcc.bal_changed = this.lAcc.bal_diff !== 0
      this.$forceUpdate()
    },
    getEmptyAcc () {
      var emptyAcc = {
        comm_id: config.COMM_ID,
        gl_acc_id: -1,
        bc_acc_name: '',
        bc_acc_type: '',
        bc_acc_bal: '',
        bank_acc_type: '',
        is_alert_min_bal: false,
        no_tran_yet: true
      }
      return emptyAcc
    },
    saveChanges (curAct) {
      if (curAct !== 'delete') {
        if (!this.$refs.lForm.validate()) {
          return
        }
        this.lAcc.bc_acc_bal = this.lAcc.bc_acc_bal || 0
      }
      this.beingSaved = true
      // pre-req
      if (curAct === 'update') {
        if (this.lAcc.prev_acc_name !== this.lAcc.bc_acc_name || this.lAcc.prev_acc_type !== this.lAcc.bank_acc_type) {
          this.lAcc.gl_attr_changed = true
        } else {
          this.lAcc.gl_attr_changed = false
        }
      }

      if (this.lAcc.debit_gl_acc_id && this.lAcc.debit_gl_acc_id.gl_acc_name) {
        this.lAcc.debit_gl_acc_name = this.lAcc.debit_gl_acc_id.gl_acc_name
        this.lAcc.debit_gl_acc_id = this.lAcc.debit_gl_acc_id.gl_acc_id
      }
      if (this.lAcc.credit_gl_acc_id && this.lAcc.credit_gl_acc_id.gl_acc_name) {
        this.lAcc.credit_gl_acc_name = this.lAcc.credit_gl_acc_id.gl_acc_name
        this.lAcc.credit_gl_acc_id = this.lAcc.credit_gl_acc_id.gl_acc_id
      }

      this.axios.post(config.API_URL + '/bank/' + curAct, this.lAcc)
      .then(response => {
        // update the frontend
        this.loadAccs()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    deleteAcc () {
      // confirm
      if (confirm('Sure, you want to delete the account "' + this.lAcc.bc_acc_name + '"?')) {
        // delete
        this.saveChanges('delete')
      }
    }
  } // methods
} // export
</script>



// WEBPACK FOOTER //
// Bank.vue?68c5ea44